import {useTranslation} from "react-i18next"
import {useModel} from "hooks"
import styles from "./CalendarTimezoneLabel.module.css"

export function CalendarTimezoneLabel() {
    const model = useModel()
    const {t} = useTranslation(["calendar"])

    return (
        <p className={styles.label}>
            {t("calendar.timezone")}: {model.getUserTimezone()}
        </p>
    )
}
